import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomModal,
  InputNumeroDecimal,
} from '../../../../components'
import { errorHandler } from '../../../../services/util/error.service'
import InsumoHttp from '../../../../services/api/https/insumos/insumo.http'

export default function EntradaSaidaInsumoModal({
  visible = false,
  onResponse,
  movimentacao = null,
  insumos = [],
  operacoes = [],
}) {
  // Hooks
  const [mov, setMov] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (visible && movimentacao) {
      setMov(movimentacao)
    }
  }, [visible])

  useEffect(() => {
    isLoading && salvarEntradaSaidaInsumo()
  }, [isLoading])

  // Helpers
  const salvarEntradaSaidaInsumo = async () => {
    try {
      validacao()
      const movimento = await InsumoHttp.inserirMovimentoInsumo(mov)
      onResponse('success', movimento)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }
  const validacao = () => {
    if (mov.insumo === '') throw new Error('O Campo Insumo é obrigatório')
    if (mov.operacao === '') throw new Error('O Campo Operação é obrigatório')
    if (mov.qte <= 0) throw new Error('O Campo Quantidade deve ser maior que zero')
  }
  // Render
  return (
    <CustomModal
      onClose={() => onResponse('close')}
      isVisible={visible}
      width={600}
      header={mov ? 'Visualizando a Movimentação' : 'Nova Movimentação'}
    >
      <div className="p-grid">
        <div className="p-col-4">
          <CustomCalendar
            label={'Data da Movimentação'}
            marginTop={0}
            value={mov ? mov.data_movimentacao : ''}
            onChange={value => setMov({ ...mov, data_movimentacao: value })}
          />
        </div>
        <div className="p-col-12">
          <CustomDropdown
            label={'Insumo'}
            marginTop={0}
            options={insumos}
            optionLabel={'insumoName'}
            onChange={value => setMov({ ...mov, insumo: value })}
            value={mov ? mov.insumo : ''}
          />
        </div>
        <div className="p-col-8">
          <CustomDropdown
            label={'Operação'}
            marginTop={0}
            options={operacoes}
            optionLabel={'name'}
            onChange={value => setMov({ ...mov, operacao: value })}
            value={mov ? mov.operacao : ''}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            label={'Quantidade'}
            marginTop={0}
            value={mov ? mov.qte : ''}
            onChange={value => setMov({ ...mov, qte: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => setIsLoading(true)} isLoading={isLoading}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
